import React from "react";
import styles from "./SkeletonTable.module.css";

const SkeletonTable = ({ rows = 10 }) => {
  return (
    <div className={styles.skeletonTable}>
      {[...Array(rows)].map((_, i) => (
        <div key={i} className={styles.skeletonRow}></div>
      ))}
    </div>
  );
};

export default SkeletonTable;